import { Order, OrderType } from "@/models";
import { ethers } from "ethers";
import EthCrypto from "eth-crypto";
import { LocalStorageKeys } from "@/constants";

export const parseBigNumber = (bigNumber: ethers.BigNumberish): string => {
  return ethers.utils.formatUnits(bigNumber, "wei");
};

export const getDecryptedUPI = async (encUpi: string) => {
  try {
    const relayIdentity = JSON.parse(
      localStorage.getItem(LocalStorageKeys.RELAY_IDENTITY) as string,
    );
    const privateKey = relayIdentity?.privateKey;
    if (!privateKey) {
      throw new Error("Private key not found in relay identity.");
    }
    if (typeof encUpi !== "string") {
      throw new Error("Encrypted UPI is not a valid string.");
    }
    const encryptedObject = EthCrypto.cipher.parse(encUpi);
    const decrypted = await EthCrypto.decryptWithPrivateKey(
      privateKey,
      encryptedObject,
    );
    const decryptedPayload = JSON.parse(decrypted);
    const decryptedMessage = decryptedPayload.message;
    if (decryptedMessage) {
      return decryptedMessage;
    } else {
      throw new Error(
        `Got nothing when decrypting the UPI ID: , ${decryptedMessage}`,
      );
    }
  } catch (error) {
    console.error("Had trouble fetching the relay identity: ", error);
  }
};

export const parseOrder = async (order: Order) => {
  const decUpi =
    order.encUpi && order.orderType === OrderType.SELL
      ? await getDecryptedUPI(order.encUpi)
      : order.encUpi;
  return {
    amount: parseBigNumber(order.amount),
    fiatAmount: parseBigNumber(order.fiatAmount),
    placedTimestamp: parseBigNumber(order.placedTimestamp),
    completedTimestamp: parseBigNumber(order.completedTimestamp),
    userCompletedTimestamp: parseBigNumber(order.userCompletedTimestamp),
    assignedMerchants: order.assignedMerchants?.map((address: string) =>
      address.toString(),
    ),
    acceptedMerchant: order.acceptedMerchant.toString(),
    user: order.user.toString(),
    recipientAddr: order.recipientAddr.toString(),
    pubkey: order.pubkey,
    encUpi: decUpi,
    userCompleted: order.userCompleted,
    status: order.status,
    orderType: order.orderType,
    disputeInfo: {
      raisedBy: order.disputeInfo.raisedBy,
      status: order.disputeInfo.status,
      redactTransId: order.disputeInfo.redactTransId.toString(),
      accountNumber: order.disputeInfo.accountNumber.toString(),
    },
    id: parseBigNumber(order.id),
  };
};

export const parsedOrderArr = (order: Array<any>) => {
  return {
    amount: order[0],
    fiatAmount: order[1],
    placedTimestamp: order[2],
    completedTimestamp: order[3],
    userCompletedTimestamp: order[4],
    acceptedMerchant: order[5],
    user: order[6],
    recipientAddr: order[7],
    pubkey: order[8],
    encUpi: order[9],
    userCompleted: order[10],
    status: order[11],
    orderType: order[12],
    disputeInfo: {
      raisedBy: order[13]?.raisedBy || 0,
      status: order[13]?.status || 0,
      redactTransId: order[13]?.redactTransId || 0n,
      accountNumber: order[13]?.accountNumber || 0n,
    },
    id: order[14],
    assignedMerchants: [],
  };
};
